module.exports = __webpack_public_path__ + "img/Copy_URL_gold.e5151b76.png";